import { render } from "./ExtrasGroupRequired.vue?vue&type=template&id=16bf6500"
import script from "./ExtrasGroupRequired.vue?vue&type=script&lang=js"
export * from "./ExtrasGroupRequired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/leaseitnow/ExtrasGroupRequired.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16bf6500"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16bf6500', __exports__)) {
    api.reload('16bf6500', __exports__)
  }
  
  module.hot.accept("./ExtrasGroupRequired.vue?vue&type=template&id=16bf6500", () => {
    api.rerender('16bf6500', render)
  })

}


export default __exports__